var EXTERNAL_LINK_PROPS = {
    target: "_blank",
    rel: "noreferrer noopener"
};
export default EXTERNAL_LINK_PROPS;
